import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=e10433ce&scoped=true"
import script from "./PaymentsList.vue?vue&type=script&lang=js"
export * from "./PaymentsList.vue?vue&type=script&lang=js"
import style0 from "./PaymentsList.vue?vue&type=style&index=0&id=e10433ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10433ce",
  null
  
)

export default component.exports